import React from 'react';
import Header from '../header';
import HeroSection from '../aboutUs/heroSection';
import WhoAreWe from '../aboutUs/whoAreWe';
import ValuesSection from '../aboutUs/ourValues';
import OurMissions from '../aboutUs/ourMissions';
import ImpactSection from '../aboutUs/impactSection';
import Achievements from '../achievements';
import WantToBePart from '../aboutUs/wantToBePart';
import AccentSection from '../aboutUs/accentSection';
import Footer from '../footer';

const aboutUsPage = () => {
    return (
        <div>
            <Header />
            <HeroSection />
            <WhoAreWe />
            <ValuesSection />
            <OurMissions />
            <ImpactSection />
            <Achievements />
            <WantToBePart />
            <AccentSection />
            <Footer />
        </div>
    );
}

export default aboutUsPage;